export function formatPace(metersPerSec) {
  if (!metersPerSec || metersPerSec <= 0) return "—";
  const minPerKm = 1000 / 60 / metersPerSec;
  const mins = Math.floor(minPerKm);
  const secs = Math.round((minPerKm - mins) * 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
}

export function formatPaceValue(minPerKm) {
  const mins = Math.floor(minPerKm);
  const secs = Math.round((minPerKm - mins) * 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function getZone(hr, cfg) {
  if (!hr || !cfg) return null;
  if (hr <= cfg.z1_max) return 1;
  if (hr <= cfg.z2_max) return 2;
  if (hr <= cfg.z3_max) return 3;
  if (hr <= cfg.z4_max) return 4;
  return 5;
}

export function getZoneColor(hr, cfg) {
  const zone = getZone(hr, cfg);
  if (!zone) return "#aaa";
  return ZONE_COLORS[zone];
}

export function getPaceColor(velocity, minV, maxV) {
  if (!velocity || maxV === minV) return "#95A5A6";
  const t = (velocity - minV) / (maxV - minV);
  if (t < 0.25) return "#3498DB";
  if (t < 0.5) return "#27AE60";
  if (t < 0.75) return "#F39C12";
  return "#E74C3C";
}

export function decodePolyline(encoded) {
  if (!encoded) return [];
  let index = 0,
    lat = 0,
    lng = 0;
  const coordinates = [];
  while (index < encoded.length) {
    let shift = 0,
      result = 0,
      byte;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lat += result & 1 ? ~(result >> 1) : result >> 1;
    shift = 0;
    result = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lng += result & 1 ? ~(result >> 1) : result >> 1;
    coordinates.push([lng / 1e5, lat / 1e5]);
  }
  return coordinates;
}

export const ZONE_COLORS = { 1: "#95A5A6", 2: "#27AE60", 3: "#F39C12", 4: "#E67E22", 5: "#C0392B" };
export const ZONE_LABELS = { 1: "Zone 1", 2: "Zone 2", 3: "Zone 3", 4: "Zone 4", 5: "Zone 5" };

export const CHART_TABS = [
  { key: "hr", label: "Heart Rate", color: "#C0392B" },
  { key: "pace", label: "Pace", color: "#2E75B6" },
  { key: "elevation", label: "Elevation", color: "#27AE60" },
];

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
